<div class="p-3">
  <mat-card class="mb-3">
    <!--  Todo: implement in seperate component -->
    <mat-card-title-group>
      <mat-card-title>Opret fond</mat-card-title>
      <mat-card-subtitle>Stamdata</mat-card-subtitle>
    </mat-card-title-group>
    <mat-card-content>
      <form [formGroup]="form">
        <div fxLayout fxLayoutGap="10px">
          <div fxFlex="25" fxLayout="column" fxLayoutGap="10px">
            <h3>Trin 1: CVR-nummer, domæne & sprog</h3>
            <mat-form-field color="primary">
              <mat-label>CVR-nummer</mat-label>
              <input
                matInput
                placeholder="CVR-nummer"
                formControlName="reg_no"
                (blur)="doLookupCvr()"
                autofocus>
              <mat-hint>Fondens CVR-nummer - data fra CVR-indlæses automatisk.</mat-hint>
              @if (form.controls['reg_no'].hasError('required')) {
                <mat-error>Obligatorisk.</mat-error>
              }
              @if (form.controls['reg_no'].hasError('pattern')) {
                <mat-error>Ugyldigt CVR-nummer.</mat-error>
              }
              @if (form.controls['reg_no'].hasError('minlength')) {
                <mat-error>Mindst 8 cifre.</mat-error>
              }
              @if (form.controls['reg_no'].hasError('maxlength')) {
                <mat-error>Højst 8 cifre.</mat-error>
              }
              @if (form.controls['reg_no'].hasError('unknown')) {
                <mat-error>Ukendt CVR-nummer.</mat-error>
              }
            </mat-form-field>
            <mat-form-field color="primary">
              <mat-label>Domæne</mat-label>
              <input
                matInput
                placeholder="Fondens domæne"
                formControlName="subdomain"
                (blur)="doCheckSubdomain()"
                >
              <span matSuffix>.grant.nu</span>
              <mat-hint>Et unikt underdomæne til fonden.</mat-hint>
              @if (form.controls['subdomain'].hasError('required')) {
                <mat-error>Obligatorisk.</mat-error>
              }
              @if (form.controls['subdomain'].hasError('minlength')) {
                <mat-error>Mindst 3 tegn.</mat-error>
              }
              @if (form.controls['subdomain'].hasError('maxlength')) {
                <mat-error>Højst 60 tegn.</mat-error>
              }
              @if (form.controls['subdomain'].hasError('pattern')) {
                <mat-error>Ugyldigt domænenavn.</mat-error>
              }
              @if (form.controls['subdomain'].hasError('taken')) {
                <mat-error>Allerede taget.</mat-error>
              }
            </mat-form-field>
            <mat-form-field color="primary">
              <mat-label>Alternativ domæne</mat-label>
              <input
                matInput
                placeholder="Fondens alternativ domæne"
                formControlName="c_name"
              >
              <mat-hint>Alternativ domæne til ansøger profilen</mat-hint>
              @if (form.controls['c_name'].hasError('pattern')) {
                <mat-error>Ugyldigt domænenavn.</mat-error>
              } @else if (form.controls['c_name'].hasError('cNameConflict')) {
                <mat-error>Mangler at blive udfyldt</mat-error>
              }
            </mat-form-field>
            <mat-form-field color="primary">
              <mat-label>Alternativ domæne til filer</mat-label>
              <input
                matInput
                placeholder="Fondens alternativ domæne til at hente filer"
                formControlName="c_name_resource"
              >
              <mat-hint>Alternativ domæne til at hente filer via ansøger profilen</mat-hint>
              @if (form.controls['c_name_resource'].hasError('pattern')) {
                <mat-error>Ugyldigt domænenavn.</mat-error>
              } @else if (form.controls['c_name_resource'].hasError('cNameConflict')) {
                <mat-error>Mangler at blive udfyldt</mat-error>
              }
            </mat-form-field>
            <mat-form-field color="primary" class="mt-3">
              <mat-label>Mulige sprog i board</mat-label>
              <mat-select formControlName="board_languages" multiple>
                @for (lang of languages; track lang) {
                  <mat-option [value]="lang.code">{{lang.name}}</mat-option>
                }
              </mat-select>
            </mat-form-field>
            <mat-form-field color="primary">
              <mat-label>Mulige sprog for ansøger</mat-label>
              <mat-select formControlName="base_languages" multiple>
                @for (lang of languages; track lang) {
                  <mat-option [value]="lang.code">{{lang.name}}</mat-option>
                }
              </mat-select>
            </mat-form-field>
            <mat-form-field color="primary" class="mt-3">
              <mat-label>Tidszone</mat-label>
              <mat-select formControlName="time_zone">
                @for (tz of timeZones; track tz) {
                  <mat-option [value]="tz.code">{{tz.name}}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
          <mat-divider [vertical]="true"></mat-divider>
          <div fxFlex="25" fxLayout="column" fxLayoutGap="10px">
            <h3>Trin 2: Kontaktperson</h3>
            <mat-form-field color="primary">
              <mat-label>Navn</mat-label>
              <input
                matInput
                placeholder="Kontaktpersonens navn"
                formControlName="contact">
              <mat-hint>Navnet på fondens kontaktperson.</mat-hint>
              @if (form.controls['contact'].hasError('required')) {
                <mat-error>Obligatorisk.</mat-error>
              }
              @if (form.controls['contact'].hasError('maxlength')) {
                <mat-error>Højst 100 tegn.</mat-error>
              }
            </mat-form-field>
            <mat-form-field color="primary">
              <mat-label>E-mail</mat-label>
              <input
                matInput
                placeholder="E-mail"
                formControlName="email">
              <mat-hint>Kontaktpersonens eller fondens email.</mat-hint>
              @if (form.controls['email'].hasError('required')) {
                <mat-error>Obligatorisk.</mat-error>
              }
              @if (form.controls['email'].hasError('maxlength')) {
                <mat-error>Højst 100 tegn.</mat-error>
              }
              @if (form.controls['email'].hasError('email')) {
                <mat-error>Ugyldig e-mail.</mat-error>
              }
            </mat-form-field>
            <mat-form-field color="primary">
              <mat-label>Telefon</mat-label>
              <input
                matInput
                placeholder="Telefonnummer"
                formControlName="phone">
              <mat-hint>Kontaktpersonens eller fondens telefonnummer.</mat-hint>
              @if (form.controls['phone'].hasError('required')) {
                <mat-error>Obligatorisk.</mat-error>
              }
              @if (form.controls['phone'].hasError('maxlength')) {
                <mat-error>Højst 16 cifre.</mat-error>
              }
              @if (form.controls['phone'].hasError('pattern')) {
                <mat-error>Ugyldigt telefonnummer.</mat-error>
              }
            </mat-form-field>
          </div>
          <mat-divider [vertical]="true"></mat-divider>
          <div fxFlex="25" fxLayout="column" fxLayoutGap="10px">
            <h3>Trin 3: Adresse</h3>
            <mat-form-field color="primary">
              <mat-label>Navn</mat-label>
              <input
                matInput
                placeholder="Fondens navn"
                formControlName="name">
              <mat-hint>Fondens navn, som det vises i GrantOne.</mat-hint>
              @if (form.controls['name'].hasError('required')) {
                <mat-error>Obligatorisk.</mat-error>
              }
              @if (form.controls['name'].hasError('maxlength')) {
                <mat-error>Højst 100 tegn.</mat-error>
              }
            </mat-form-field>
            <mat-form-field color="primary">
              <mat-label>C/O</mat-label>
              <input
                matInput
                placeholder="Evt. c/o adresse"
                formControlName="care_of">
              @if (form.controls['care_of'].hasError('maxlength')) {
                <mat-error>Højst 100 tegn.</mat-error>
              }
            </mat-form-field>
            <mat-form-field color="primary">
              <mat-label>Vej/Gade</mat-label>
              <input
                matInput
                placeholder="Vej/gadenavn, fx Hovedgaden 84B"
                formControlName="street">
              @if (form.controls['street'].hasError('required')) {
                <mat-error>Obligatorisk.</mat-error>
              }
              @if (form.controls['street'].hasError('maxlength')) {
                <mat-error>Højst 100 tegn.</mat-error>
              }
            </mat-form-field>
            <div fxLayout="row" fxLayoutGap="10px">
              <mat-form-field color="primary" fxFlex="25">
                <mat-label>Postnr.</mat-label>
                <input
                  matInput
                  placeholder="Postnr."
                  formControlName="zip">
                @if (form.controls['zip'].hasError('required')) {
                  <mat-error>Obligatorisk.</mat-error>
                }
                @if (form.controls['zip'].hasError('maxlength')) {
                  <mat-error>Højst 20 tegn.</mat-error>
                }
              </mat-form-field>
              <mat-form-field color="primary" fxFlex="75">
                <mat-label>By</mat-label>
                <input
                  matInput
                  placeholder="By"
                  formControlName="city">
                @if (form.controls['city'].hasError('required')) {
                  <mat-error>Obligatorisk.</mat-error>
                }
                @if (form.controls['city'].hasError('maxlength')) {
                  <mat-error>Højst 100 tegn.</mat-error>
                }
              </mat-form-field>
            </div>
            <mat-form-field color="primary">
              <mat-label>Region</mat-label>
              <input
                matInput
                placeholder="Evt. region"
                formControlName="region">
              @if (form.controls['region'].hasError('maxlength')) {
                <mat-error>Højst 100 tegn.</mat-error>
              }
            </mat-form-field>
            <mat-form-field color="primary">
              <mat-label>Land</mat-label>
              <mat-select formControlName="country">
                @for (country of countries; track country) {
                  <mat-option [value]="country.value">{{country.name}}</mat-option>
                }
              </mat-select>
              @if (form.controls['country'].hasError('required')) {
                <mat-error>Land skal besvares.</mat-error>
              }
            </mat-form-field>
          </div>
          <mat-divider [vertical]="true"></mat-divider>
          <div fxFlex="25" fxLayout="column" fxLayoutGap="10px">
            <h3>Trin 4: Bankoplysninger</h3>
            <mat-form-field color="primary">
              <mat-label>Bank</mat-label>
              <mat-select formControlName="bank">
                <mat-option value="generic">Ingen/generisk</mat-option>
                <mat-option value="danske_forvaltning">Danske Bank Forvaltning</mat-option>
                <mat-option value="danske_bank">Danske Bank District</mat-option>
                <mat-option value="jyske_bank">Jyske Bank</mat-option>
                <mat-option value="bank_connect">BankConnect</mat-option>
                <mat-option value="bank_integration">BankIntegration</mat-option>
              </mat-select>
              <mat-hint>Vælg hvilken bank-integration, som fonden skal benytte.</mat-hint>
              @if (form.controls['bank'].hasError('required')) {
                <mat-error>Obligatorisk.</mat-error>
              }
            </mat-form-field>
            <mat-form-field color="primary">
              <mat-label>Depot-/kontonummer</mat-label>
              <input
                matInput
                placeholder="Depot-/kontonummer"
                formControlName="custody_no"
                >
              <mat-hint>Angiv registrerings- og kontonummer for fondens depot.</mat-hint>
              @if (form.controls['custody_no'].hasError('required')) {
                <mat-error>Obligatorisk.</mat-error>
              }
              @if (form.controls['custody_no'].hasError('maxlength')) {
                <mat-error>Højst 15 cifre.</mat-error>
              }
              @if (form.controls['custody_no'].hasError('minlength')) {
                <mat-error>Mindst 8 cifre.</mat-error>
              }
              @if (form.controls['custody_no'].hasError('pattern')) {
                <mat-error>Ugyldigt depotnummer.</mat-error>
              }
            </mat-form-field>
            <mat-form-field color="primary">
              <mat-label>Valuta</mat-label>
              <mat-select formControlName="currency">
                <mat-option value="dkk">Danske kroner</mat-option>
                <mat-option value="eur">Euro</mat-option>
                <mat-option value="usd">US Dollar</mat-option>
                <mat-option value="sek">Svenske kroner</mat-option>
                <mat-option value="nok">Norske kroner</mat-option>
                <mat-option value="isk">Islandske kroner</mat-option>
              </mat-select>
              @if (form.controls['currency'].hasError('required')) {
                <mat-error>Obligatorisk.</mat-error>
              }
            </mat-form-field>
            @if (form.controls['bank'].value === 'danske_forvaltning') {
              <mat-form-field color="primary"
                >
                <mat-label>Kapital</mat-label>
                <mat-select formControlName="capital">
                  <mat-option [value]="0">Under 1 million kr.</mat-option>
                  <mat-option [value]="1">Over 1 million kr.</mat-option>
                </mat-select>
              </mat-form-field>
            }
            <mat-slide-toggle
              color="primary"
              matTooltip="Angiver om fonden har en NemKonto aftale til udbetalinger."
              formControlName="nem_konto" ngDefaultControl
            >NemKonto</mat-slide-toggle>
            @if (form.controls['bank'].value === 'danske_forvaltning') {
              <mat-slide-toggle
                color="primary"
                matTooltip="Angiver om fonden er regnskabskunde eller ej.."
                formControlName="accounting"
              >Regnskabskunde hos Danske Bank Forvaltning</mat-slide-toggle>
            }
          </div>
        </div>
      </form>
    </mat-card-content>
    <mat-card-footer>
      @if (form.disabled) {
        <mat-progress-bar mode="indeterminate" color="accent"></mat-progress-bar>
      }
    </mat-card-footer>
  </mat-card>
  <mat-card class="mb-3">
    <!--  Todo: implement in seperate component -->
    <div fxFlex="40">
      <mat-card-title-group>
        <mat-card-title>Kategorier</mat-card-title>
        <mat-card-subtitle>Opret en eller flere kategorier.</mat-card-subtitle>
      </mat-card-title-group>
      <mat-card-content>
        <form [formGroup]="categoriesForm" fxLayout="column" fxLayoutGap="10px">
          @for (category of categories; track category; let i = $index) {
            <div
              formArrayName="categories"
              class="mb-3"
              >
              <div [formGroupName]="i" class="category" fxLayout="row" fxLayoutGap="10px">
                <mat-form-field color="primary" fxFlex="60">
                  <mat-label>Kategori #{{i + 1}}</mat-label>
                  <input
                    matInput
                    formControlName="name"
                    placeholder="Kategorinavn"
                    >
                </mat-form-field>
                <mat-form-field color="primary" fxFlex="20">
                  <mat-label>Initialer</mat-label>
                  <input
                    matInput
                    formControlName="initials"
                    placeholder="Initialer"
                    >
                </mat-form-field>
                <div fxFlex="10">
                  @if (categories.length > 1) {
                    <button
                      mat-icon-button
                      matTooltip="Slet denne kategori"
                      (click)="doRemoveCategory(i)"
                      ><mat-icon>delete</mat-icon></button>
                    }
                  </div>
                </div>
              </div>
            }
          </form>
        </mat-card-content>
        <mat-card-actions>
          <button
            mat-flat-button
            color="accent"
            matTooltip="Tilføj ny kategori"
            (click)="doAppendCategory()"
            ><mat-icon>add</mat-icon> Tilføj kategori</button>
          </mat-card-actions>
        </div>
        <div fxFlex="40">
          <mat-card-title-group>
            <mat-card-title>Board brugere</mat-card-title>
            <mat-card-subtitle>Tilføj board brugere ud fra eksisterende admin brugere</mat-card-subtitle>
          </mat-card-title-group>
          <mat-card-content>
            <div fxLayout="column" fxLayoutGap="10px">
              @for (admin of allAdminUsers; track admin; let i = $index) {
                <mat-checkbox ngDefaultControl [checked]="isAdminUserSelected(admin)"
                  (change)="doToggleAdminUser(admin, $event.checked)"
                  class="mr-2">
                  {{admin.name}}
                </mat-checkbox>
              }
            </div>
          </mat-card-content>
        </div>
      </mat-card>
      <!--  Todo: implement in seperate component -->
      <mat-card class="mb-3 modules">
        <mat-card-header>
          <mat-card-title>
            Moduler
          </mat-card-title>
        </mat-card-header>
        <mat-card-content fxLayout="row wrap">
          <div fxFlex="100">
            <mat-form-field class="mr-3">
              <mat-label>Søg efter modul</mat-label>
              <input type="text" name="search"
                [(ngModel)]="searchString"
                matInput
                (keyup)="search()">
            </mat-form-field>
            <button (click)="toggleAll()"
              class="mb-3"
              mat-flat-button
              [color]="showChooseAll() ? 'accent' : 'primary'">
              @if (showChooseAll()) {
                <span>Vælg alle</span>
              }
              @if (!showChooseAll()) {
                <span>Fravælg alle</span>
              }
            </button>
          </div>
          <div fxFlex="55">
            <mat-grid-list cols="3" rowHeight="3em"
              fxLayoutGap="1em"
              [@listAnimation]="filteredComponents.length">
              @for (component of filteredComponents; track component) {
                <mat-grid-tile fxFlex="30" colspan="1" rowspan="1">
                  <mat-card fxFlex="100">
                    <mat-card-content fxLayoutAlign="space-between center" fxFlex>
                      <span>{{component.name}}</span>
                      <mat-slide-toggle [checked]="selectedComponents.includes(component.id)"
                        (change)="selectComponent(component.id, $event.checked)"
                      color="primary" class="mr-2"></mat-slide-toggle>
                    </mat-card-content>
                  </mat-card>
                </mat-grid-tile>
              }
            </mat-grid-list>
          </div>
        </mat-card-content>
      </mat-card>
      <mat-card>
        <mat-card-content>
          <div fxLayout="row" fxLayoutAlign="flex-end center" fxLayoutGap="10px">
            <div>Det kan tage op til et minut at oprette en fond.</div>
            <button
              mat-flat-button
              color="primary"
              [disabled]="form.disabled "
              (click)="doCreate()"
              ><mat-icon>verified</mat-icon> Opret fond</button>
            </div>
          </mat-card-content>
        </mat-card>
      </div>
